import DashboardBoard from "./DashboardBoard";

export default function Dashboard() {
  return <DashboardBoard />;
}
